import { COMPANYGROUPBYCOMPANYLIST_SEARCH, COMPANYGROUPBYCOMPANYLIST_PAGE } from '../actions/companygroupbycompanylistactions';

const state = { search:'', page:0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [COMPANYGROUPBYCOMPANYLIST_SEARCH]: ({ commit }, search) => {
        commit(COMPANYGROUPBYCOMPANYLIST_SEARCH, search);
    },
    [COMPANYGROUPBYCOMPANYLIST_PAGE]: ({ commit }, page) => {
        commit(COMPANYGROUPBYCOMPANYLIST_PAGE, page);
    }
};

const mutations = {
    [COMPANYGROUPBYCOMPANYLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [COMPANYGROUPBYCOMPANYLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};